export default __webpack_public_path__ + "static/media/file-add.1302710d.svg";